/**
 * The absolute address of one of the app's own routes — what Accounts has to be handed in order
 * to send the browser back here.
 */
export const appUrl = path => `${window.location.origin}${path}`

// The trip to Accounts leaves from this tab rather than a new one: the drive is what the person is
// signing in to, and the callback route finishes the sign-in where they started it.
export const openAuthorization = uri => window.location.assign(encodeURI(uri))
